import React, { useState, createContext } from 'react';

// Создаем контекст
const ProjectContext = createContext();

// Провайдер для керування підказками робот-козака
const ProjectProvider = ({ children }) => {
  const [advice, setAdvice] = useState(false);
  const [projects, setProjects] = useState(
    JSON.parse(localStorage.getItem('projects')) || []
);




  // Функция для перемикання
  const toggleAdvice= (e) => {
    setAdvice(e);
  };

  return (
    <ProjectContext.Provider value={{ advice, toggleAdvice, projects, setProjects }}>
      {children}
    </ProjectContext.Provider>
  );
};

export { ProjectContext, ProjectProvider };